import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { StorageService } from './storage.service';
import { RemoteDataService } from './remote-data.service';
import { catchError, switchMap, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  private accessToken = '';
  constructor(private storageService: StorageService) {
    if (environment.useAuth0) {
      this.storageService.accessToken.subscribe(val => {
        this.accessToken = val;
      })
    }
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (environment.useAuth0) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.accessToken}`
        }
      });
      return next.handle(request)
    }
    return next.handle(request);
  }
}
